// extracted by mini-css-extract-plugin
export var cardLayout = "_2d-1";
export var paginationContainer = "_2d-0";